<template>
  <svg
    fill="none"
    height="336"
    viewBox="0 0 712 336"
    width="712"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      fill="#F8FAFB"
      height="80"
      opacity="0.06"
      rx="8"
      transform="rotate(180 248 376)"
      width="80"
      x="248"
      y="376"
    />
    <rect
      fill="url(#paint0_linear_107_9000)"
      height="80"
      opacity="0.03"
      rx="8"
      transform="rotate(180 164 124)"
      width="80"
      x="164"
      y="124"
    />
    <rect
      fill="url(#paint1_linear_107_9000)"
      height="80"
      opacity="0.06"
      rx="8"
      transform="rotate(180 80 40)"
      width="80"
      x="80"
      y="40"
    />
    <rect
      fill="url(#paint2_linear_107_9000)"
      height="80"
      opacity="0.04"
      rx="8"
      transform="rotate(180 164 376)"
      width="80"
      x="164"
      y="376"
    />
    <rect
      fill="#F3F5F7"
      height="80"
      opacity="0.06"
      rx="8"
      transform="rotate(180 164 40)"
      width="80"
      x="164"
      y="40"
    />
    <rect
      fill="url(#paint3_linear_107_9000)"
      height="80"
      opacity="0.04"
      rx="8"
      transform="rotate(180 248 292)"
      width="80"
      x="248"
      y="292"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      opacity="0.04"
      rx="8"
      transform="rotate(180 248 208)"
      width="80"
      x="248"
      y="208"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      opacity="0.02"
      rx="8"
      transform="rotate(180 248 124)"
      width="80"
      x="248"
      y="124"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      opacity="0.12"
      rx="8"
      transform="rotate(180 248 40)"
      width="80"
      x="248"
      y="40"
    />
    <rect
      fill="#F8F8FA"
      height="80"
      opacity="0.02"
      rx="8"
      transform="rotate(180 332 376)"
      width="80"
      x="332"
      y="376"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      opacity="0.06"
      rx="8"
      transform="rotate(180 332 292)"
      width="80"
      x="332"
      y="292"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      opacity="0.12"
      rx="8"
      transform="rotate(180 332 124)"
      width="80"
      x="332"
      y="124"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      opacity="0.02"
      rx="8"
      transform="rotate(180 332 40)"
      width="80"
      x="332"
      y="40"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      opacity="0.12"
      rx="8"
      transform="rotate(180 416 376)"
      width="80"
      x="416"
      y="376"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      opacity="0.12"
      rx="8"
      transform="rotate(180 416 292)"
      width="80"
      x="416"
      y="292"
    />
    <rect
      fill="#F3F5F7"
      height="80"
      opacity="0.06"
      rx="8"
      transform="rotate(180 416 208)"
      width="80"
      x="416"
      y="208"
    />
    <rect
      fill="url(#paint4_linear_107_9000)"
      height="80"
      opacity="0.02"
      rx="8"
      transform="rotate(180 164 208)"
      width="80"
      x="164"
      y="208"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      opacity="0.08"
      rx="8"
      transform="rotate(180 416 124)"
      width="80"
      x="416"
      y="124"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      opacity="0.06"
      rx="8"
      transform="rotate(180 416 40)"
      width="80"
      x="416"
      y="40"
    />
    <rect
      fill="#F2F5F9"
      height="80"
      opacity="0.12"
      rx="8"
      transform="rotate(180 500 376)"
      width="80"
      x="500"
      y="376"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      opacity="0.08"
      rx="8"
      transform="rotate(180 500 292)"
      width="80"
      x="500"
      y="292"
    />
    <rect
      fill="#F6F8F8"
      height="80"
      opacity="0.08"
      rx="8"
      transform="rotate(180 500 208)"
      width="80"
      x="500"
      y="208"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      opacity="0.12"
      rx="8"
      transform="rotate(180 500 124)"
      width="80"
      x="500"
      y="124"
    />
    <rect
      fill="#F2F5F9"
      height="80"
      opacity="0.02"
      rx="8"
      transform="rotate(180 584 376)"
      width="80"
      x="584"
      y="376"
    />
    <rect
      fill="#EBEDF5"
      height="80"
      opacity="0.12"
      rx="40"
      transform="rotate(180 584 292)"
      width="80"
      x="584"
      y="292"
    />
    <path
      d="M546.922 248.223V244.9H554.481V239.656H533.497V244.9H541.078V248.223C534.727 248.528 529.959 249.803 529.959 251.33C529.959 252.858 534.722 254.125 541.078 254.438V265.406H546.922V254.438C553.273 254.135 558.041 252.86 558.041 251.33C558.041 249.8 553.278 248.528 546.922 248.223ZM544 253.445C537.123 253.445 531.547 252.382 531.547 251.102C531.547 250 535.609 249.075 541.073 248.828V252.582C542.013 252.624 542.991 252.648 543.995 252.648C544.999 252.648 545.981 252.624 546.916 252.582V248.828C552.38 249.075 556.442 250 556.442 251.102C556.452 252.396 550.877 253.445 544 253.445Z"
      fill="white"
    />
    <rect
      fill="#F1F5F9"
      height="80"
      opacity="0.12"
      rx="40"
      transform="rotate(180 500 40)"
      width="80"
      x="500"
      y="40"
    />
    <path
      d="M467.371 4.25516V0.9375L464.672 2.49406V5.81437L467.371 4.25516Z"
      fill="white"
    />
    <path
      d="M467.371 -4.25539L464.571 -5.87305L460 -3.23273L455.429 -5.87305L452.629 -4.25539V-1.31492L457.277 1.37055V6.9407L460 8.5132L462.723 6.9407V1.37055L467.371 -1.31492V-4.25539Z"
      fill="white"
    />
    <path
      d="M452.629 4.25516L455.328 5.81437V2.49406L452.629 0.9375V4.25516Z"
      fill="white"
    />
    <path
      d="M462.723 9.19336L460 10.7659L457.277 9.19336V12.3384L460 13.9109L462.723 12.3384V9.19336Z"
      fill="white"
    />
    <path
      d="M469.321 -0.18873V5.38143L464.672 8.0669V11.2119L472.046 6.95393V-1.76123L469.321 -0.18873Z"
      fill="white"
    />
    <path
      d="M455.328 8.0669L450.679 5.38143V-0.18873L447.954 -1.76123V6.95393L455.328 11.2119V8.0669Z"
      fill="white"
    />
    <rect
      fill="#F2F5F9"
      height="80"
      opacity="0.02"
      rx="8"
      transform="rotate(180 584 208)"
      width="80"
      x="584"
      y="208"
    />
    <rect
      fill="#F2F5F9"
      height="80"
      opacity="0.06"
      rx="8"
      transform="rotate(180 584 124)"
      width="80"
      x="584"
      y="124"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      opacity="0.08"
      rx="8"
      transform="rotate(180 584 40)"
      width="80"
      x="584"
      y="40"
    />
    <rect
      fill="#F2F5F9"
      height="80"
      opacity="0.12"
      rx="8"
      transform="rotate(180 668 376)"
      width="80"
      x="668"
      y="376"
    />
    <rect
      fill="#F2F5F9"
      height="80"
      opacity="0.06"
      rx="8"
      transform="rotate(180 668 292)"
      width="80"
      x="668"
      y="292"
    />
    <rect
      fill="#F2F5F9"
      height="80"
      opacity="0.08"
      rx="8"
      transform="rotate(180 668 208)"
      width="80"
      x="668"
      y="208"
    />
    <rect
      fill="#EBEDF5"
      height="80"
      opacity="0.12"
      rx="40"
      transform="rotate(180 668 124)"
      width="80"
      x="668"
      y="124"
    />
    <path
      d="M635.91 75.3911L616.14 71.999L626.499 98.187L641.281 80.5229L635.91 75.3911ZM635.554 77.0353L638.742 80.0714L630.922 81.1471L635.554 77.0353ZM628.648 81.2401L619.853 74.0921L633.979 76.5146L628.648 81.2401ZM627.904 82.4832L626.364 93.9768L618.95 75.2051L627.904 82.4832ZM629.307 82.8153L638.55 81.5429L627.753 94.4443L629.307 82.8153Z"
      fill="white"
    />
    <rect
      fill="#F6F8F9"
      height="80"
      opacity="0.02"
      rx="8"
      transform="rotate(180 668 40)"
      width="80"
      x="668"
      y="40"
    />
    <rect
      fill="#F2F5F9"
      height="80"
      opacity="0.12"
      rx="8"
      transform="rotate(180 752 376)"
      width="80"
      x="752"
      y="376"
    />
    <rect
      fill="#EBEDF5"
      height="80"
      opacity="0.12"
      rx="40"
      transform="rotate(180 332 208)"
      width="80"
      x="332"
      y="208"
    />
    <path
      d="M292 160.254L301.451 166.417L292 152.859L282.767 166.425L292 160.254Z"
      fill="white"
    />
    <path
      d="M301.539 167.995L292 162.005L282.461 168L292 173.995L301.539 167.995Z"
      fill="white"
    />
    <path
      d="M282.549 169.575L292 183.14L301.233 169.572L292 175.745L282.549 169.575Z"
      fill="white"
    />
    <rect
      fill="#F4F6F8"
      height="80"
      opacity="0.08"
      rx="8"
      transform="rotate(180 752 292)"
      width="80"
      x="752"
      y="292"
    />
    <rect
      fill="#F4F6F8"
      height="80"
      opacity="0.02"
      rx="8"
      transform="rotate(180 752 208)"
      width="80"
      x="752"
      y="208"
    />
    <rect
      fill="#F2F5F9"
      height="80"
      opacity="0.08"
      rx="8"
      transform="rotate(180 752 124)"
      width="80"
      x="752"
      y="124"
    />
    <rect
      fill="#F2F5F9"
      height="80"
      opacity="0.08"
      rx="8"
      transform="rotate(180 752 40)"
      width="80"
      x="752"
      y="40"
    />
    <defs>
      <linearGradient
        id="paint0_linear_107_9000"
        gradientUnits="userSpaceOnUse"
        x1="164"
        x2="244"
        y1="165.5"
        y2="166"
      >
        <stop stop-color="#F8FAFB" />
        <stop
          offset="1"
          stop-color="#F8FAFB"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_107_9000"
        gradientUnits="userSpaceOnUse"
        x1="80"
        x2="160"
        y1="81.5"
        y2="82"
      >
        <stop stop-color="#F8FAFB" />
        <stop
          offset="1"
          stop-color="#F8FAFB"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint2_linear_107_9000"
        gradientUnits="userSpaceOnUse"
        x1="164"
        x2="244"
        y1="417.5"
        y2="418"
      >
        <stop stop-color="#F8FAFB" />
        <stop
          offset="1"
          stop-color="#F8FAFB"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint3_linear_107_9000"
        gradientUnits="userSpaceOnUse"
        x1="248"
        x2="328"
        y1="333.5"
        y2="334"
      >
        <stop stop-color="#F8FAFB" />
        <stop
          offset="1"
          stop-color="#F8FAFB"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint4_linear_107_9000"
        gradientUnits="userSpaceOnUse"
        x1="164"
        x2="244"
        y1="249.5"
        y2="250"
      >
        <stop stop-color="#F8FAFB" />
        <stop
          offset="1"
          stop-color="#F8FAFB"
          stop-opacity="0"
        />
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'NlpSubscribeBackground',
}
</script>